import type { Resource } from '../../';
export const country_countries_US: Resource = {"default":"United States"};
